import {
  useMutation,
  useQueryClient,
  UseMutationResult,
} from "@tanstack/react-query";
import { DeleteTag } from "../../api/api"; // Adjust the import path as necessary
import { useCallback, useEffect, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import useAppContextProvider from "../../AppContext/useAppContextProvider";

type TagResult = {
  status: string;
  Msg?: string;
  errorCode?: string;
};
type tagNames = {
  tags: string[];
};

export const usePostDeleteTag = (): UseMutationResult<
  TagResult,
  Error
> => {
  const queryClient = useQueryClient();
  const {
    setToastMessage,
    setToastOpen,
    setOperationLogs,
  } = useAppContextProvider();
  const { getAccessTokenSilently, isAuthenticated } =
    useAuth0();
  const [authToken, setAuthToken] = useState<string | null>(
    null
  );

  const mutation = useMutation({
    mutationFn: (
      {
        tagNames,
        token,
      }: {
        tagNames: tagNames;
        token: string;
      },
      options?: {
        onSuccess?: (data: TagResult) => void;
        onError?: (error: any) => void;
        onSettled?: () => void;
      }
    ) => DeleteTag({ ...tagNames }, token),
    onSuccess: async (data) => {},
    onError: (error) => {},
  });

  const mutateWithToken = useCallback(
    async (
      tagNames: string[],
      options?: {
        onSuccess?: (data: TagResult) => void;
        onError?: (error: any) => void;
        onSettled?: () => void;
      }
    ) => {
      const token = await getAccessTokenSilently();
      setAuthToken(token);
      mutation.mutate(
        { tagNames, token },
        {
          onSuccess: options?.onSuccess,
          onError: options?.onError,
          onSettled: options?.onSettled,
        }
      );
    },
    [getAccessTokenSilently, mutation]
  );

  return { ...mutation, mutate: mutateWithToken };
};
